import React, { Component, Fragment } from 'react';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ErrorIcon from '@material-ui/icons/Error';
import moment from 'moment';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

const initialState = {
  reservationsToday: [],
  reservationsBefore: []
};

class CheckedInManage extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  compare = (a, b) => {
    const dateA = a.date;
    const dateB = b.date;

    let comparison = 0;
    if (dateA > dateB) {
      comparison = -1;
    } else if (dateA < dateB) {
      comparison = 1;
    }
    return comparison;
  }

  componentWillMount(){

    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-active-reservations'; //replace this with the path you have configured on your API

    API.get(apiName, path).then(response => {
      console.log(response);
      response.reservations.sort(this.compare);

      let reservationsToday = response.reservations.filter(function(item, index){
        if (item.date === moment().format("YYYY-MM-DD")) return true;
        return false;
      });

      let reservationsBefore = response.reservations.filter(function(item, index){
        if (item.date < moment().format("YYYY-MM-DD")) return true;
        return false;
      });

      this.setState({
        reservationsToday : reservationsToday,
        reservationsBefore : reservationsBefore,
      },() => {
        for(let i in this.state.reservationsToday){
          this.setState({
            [this.state.reservationsToday[i].reservation_id + "S1T"]: this.state.reservationsToday[i].status === "active_checked_in" ? "yes" : "no",
            [this.state.reservationsToday[i].reservation_id + "S2T"]: this.state.reservationsToday[i].status === "active_reserved_todo" ? "yes" : "no",
          })
        }

        for(let i in this.state.reservationsBefore){
          this.setState({
            [this.state.reservationsBefore[i].reservation_id + "S1B"]: this.state.reservationsBefore[i].status === "active_checked_in" ? "yes" : "no",
            [this.state.reservationsBefore[i].reservation_id + "S2B"]: this.state.reservationsBefore[i].status === "active_reserved_todo" ? "yes" : "no",
          })
        }

      });
    }).catch(error => {
      console.log(error);
    })
  }

  handleChangeSwitch = (event, key) => {
    let check = event.target.checked;
    console.log("event.target.checked: ", check);
    console.log("key: ", key);

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/update-active-reservations'; //replace this with the path you have configured on your API

    let reservationId = key.slice(0, -3);

    let body = {
      reservationId : reservationId,
    };

    let keyType = key.slice(-3, -1);

    console.log(reservationId);
    console.log(keyType);

    if(keyType === "S1"){
      if(check === true){
        body.status = "active_checked_in"
      }else{
        body.status = "active_reserved_complete"
      }
    }

    let myInit = {
        body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)
      this.setState({
        [key] : check ? "yes" : "no"
      });
      enqueueSnackbar(response.message, {variant : 'success'});
    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  render() {
    const {classes} = this.props
    const {
      reservationsToday,
      reservationsBefore
    } = this.state;

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              チェックイン管理
            </Typography>
          </Grid>
          <Grid item>

            <Typography variant="h6" gutterBottom　style={{display: reservationsToday.length === 0 && reservationsBefore.length === 0 ? "" : "none"}}>
              表示する予約がありません
            </Typography>

            <Paper className={classes.root} elevation={1} style={{display: reservationsToday.length === 0 ? "none" : ""}}>
              <Typography variant="h5" gutterBottom>
                本日の予約
              </Typography>
              <Table className={classes.table} style={{marginTop: 20}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お部屋</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お名前</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">チェックイン済</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reservationsToday.map(n =>
                    {
                      let s1 = n.reservation_id + "S1T";
                      let s2 = n.reservation_id + "S2T";
                      let rooms = "";
                      for(let i in n.input_rooms){
                        rooms = rooms + n.input_rooms[i]
                        if(i !== n.input_rooms.length - 1){
                          rooms = rooms + " "
                        }
                      }
                      let bg = "#d2d2d2";
                      let dp = "none";
                      if(this.state[s1] === "no"){
                        bg = "";
                      }
                      if(this.state[s2] === "yes"){
                        dp = "inline-flex";
                      }
                      return (
                        <TableRow key={n.reservation_id} style={{backgroundColor: bg}}>
                          <TableCell align="center" padding="dense">{rooms}</TableCell>
                          <TableCell align="center" padding="dense">{n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div></TableCell>
                          <TableCell align="center" padding="dense">
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state[s1] === "yes" ? true : false}
                                  onChange={(e) => this.handleChangeSwitch(e, s1)}
                                  disabled={this.state[s2] === "yes" ? true : false}
                                  value={s1}
                                  color="primary"
                                />
                              }
                              label={this.state[s1] === "yes" ? "完了" : "未　"}
                              style={{marginLeft:25}}
                            />
                          </TableCell>
                          <TableCell align="center" padding="dense">
                            <Typography variant="caption" color="error" style={{display: dp, verticalAlign:"middle", marginTop:10}}>
                              <ErrorIcon style={{marginTop: -6, marginRight:3}} />じゃらん停止前です
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            <Paper className={classes.root} elevation={1} style={{marginTop:40, display: reservationsBefore.length === 0 ? "none" : ""}}>
              <Typography variant="h5" gutterBottom>
                本日以前の予約
              </Typography>
              <Table className={classes.table} style={{marginTop: 20}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">宿泊開始日</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お部屋</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お名前</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">チェックイン済</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reservationsBefore.map(n =>
                    {
                      let s1 = n.reservation_id + "S1B";
                      let s2 = n.reservation_id + "S2B";
                      let rooms = "";
                      for(let i in n.input_rooms){
                        rooms = rooms + n.input_rooms[i]
                        if(i !== n.input_rooms.length - 1){
                          rooms = rooms + " "
                        }
                      }
                      let bg = "#d2d2d2";
                      let dp = "none";
                      if(this.state[s1] === "no"){
                        bg = "";
                      }
                      if(this.state[s2] === "yes"){
                        dp = "inline-flex";
                      }
                      return (
                        <TableRow key={n.reservation_id} style={{backgroundColor: bg}}>
                          <TableCell align="center" padding="dense">{n.date}</TableCell>
                          <TableCell align="center" padding="dense">{rooms}</TableCell>
                          <TableCell align="center" padding="dense">{n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div></TableCell>
                          <TableCell align="center" padding="dense">
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state[s1] === "yes" ? true : false}
                                  onChange={(e) => this.handleChangeSwitch(e, s1)}
                                  disabled={this.state[s2] === "yes" ? true : false}
                                  value={s1}
                                  color="primary"
                                />
                              }
                              label={this.state[s1] === "yes" ? "完了" : "未　"}
                              style={{marginLeft:25}}
                            />
                          </TableCell>
                          <TableCell align="center" padding="dense">
                            <Typography variant="caption" color="error" style={{display: dp, verticalAlign:"middle", marginTop:10}}>
                              <ErrorIcon style={{marginTop: -6, marginRight:3}} />じゃらん停止前です
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

CheckedInManage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(CheckedInManage)));
